/* Real MARKER app screenshots */
export const appScreenshots = {
  track: '/images/screenshot-track.png',
  browse: '/images/screenshot-browse.png',
  send: '/images/screenshot-send.png',
  chat: '/images/screenshot-chat.png',
  live: '/images/screenshot-live.png',
};

export const howItWorksSteps = [
  {
    step: '01',
    title: 'Pick a Drink',
    description: 'Choose a drink inside MARKER. Browse real menus from bars near you.',
    screenshot: appScreenshots.browse,
  },
  {
    step: '02',
    title: 'Send It',
    description: 'Send it to a friend or save it for yourself. Add a message.',
    screenshot: appScreenshots.send,
  },
  {
    step: '03',
    title: 'Meet & Redeem',
    description: 'They walk into the bar, show their QR code, and the drink is theirs.',
    screenshot: appScreenshots.track,
  },
];

export const appStats = [
  { label: 'Partnered Bars', value: '150+' },
  { label: 'Drinks Sent', value: '50K+' },
  { label: 'Happy Users', value: '10K+' },
  { label: 'Cities', value: '25+' },
];

export const occasions = [
  {
    id: 'birthdays',
    title: 'BIRTHDAYS',
    subtitle: 'Your round.',
    image: '/images/occasion-birthday.jpg',
  },
  {
    id: 'date-night',
    title: 'DATE NIGHT',
    subtitle: 'Drinks on me.',
    image: '/images/occasion-date.jpg',
  },
  {
    id: 'friends',
    title: 'FRIENDS',
    subtitle: 'Wish you were here.',
    image: '/images/occasion-friends.jpg',
  },
  {
    id: 'celebrations',
    title: 'CELEBRATIONS',
    subtitle: 'One for the occasion.',
    image: '/images/occasion-celebration.jpg',
  },
  {
    id: 'just-because',
    title: 'JUST BECAUSE',
    subtitle: "Thought you'd like one.",
    image: '/images/occasion-justbecause.jpg',
  },
];

export const sendDrinkSteps = [
  { num: '1', label: 'Select friend', icon: 'ri-user-add-line' },
  { num: '2', label: 'Pick a drink', icon: 'ri-goblet-line' },
  { num: '3', label: 'Add a message', icon: 'ri-chat-1-line' },
  { num: '4', label: 'Send', icon: 'ri-send-plane-line' },
];

export const socialFeatures = [
  { label: 'Sharing', desc: 'Send drinks across any distance' },
  { label: 'Chatting', desc: 'Built-in messaging & video calls' },
  { label: 'Making plans', desc: 'Coordinate your night out' },
  { label: 'Gifting', desc: 'Birthdays, dates, or just because' },
  { label: 'Meeting up', desc: 'Find each other at the bar' },
  { label: 'Creating moments', desc: 'Turn a drink into a memory' },
];

export const barBenefits = [
  { title: 'New foot traffic', desc: 'Every sent drink brings someone through your door.' },
  { title: 'Social moments', desc: 'Create shareable experiences around your bar.' },
  { title: 'Zero setup cost', desc: 'Partner with MARKER at no upfront cost.' },
  { title: 'Real analytics', desc: 'See what drinks are trending in your venue.' },
];
